<template>
    <div class="py-4 container-fluid">
      <h4 class="text-white">TURNOS</h4>
      <div class="row">
        <div class="col-md-8">
          <div class="card">
            <div class="card-body">
          <div class="nav-wrapper position-relative end-0">
  <ul class="p-1 bg-transparent nav nav-pills nav-fill">
    <li class="nav-item">
      <a class="mb-3 btn btn-sm w-100" style="cursor: pointer;" :class="{'btn-info': seleccionartap1==true}"
      @click="seleccionartap(1)"><i class="ni ni-cloud-upload-96 mr-2"></i>GESTIONAR TURNO</a>
    </li>
    <li class="nav-item">
      <a class="mb-3 btn btn-sm w-100" style="cursor: pointer;" :class="{'btn-info': seleccionartap2==true}"
      @click="seleccionartap(2)"><i class="ni ni-bell-55 mr-2"></i>VER TURNOS</a>
    </li>
  </ul>
</div>
  <div class="card-body">
    <div class="tab-content">
      <div v-show="seleccionartap1">
         <div v-show="estadoturno =='S'" class="text-center">
                 <span class="badge badge-pill badge-lg bg-gradient-info">TURNO: {{datosdelturno.turno}}</span>
              </div>
              <div v-show="estadoturno =='S'" class="row text-center">
                <div class="col-md-6">
                  <h6><strong>Nombre</strong></h6>
              <p><strong>{{datosdelturno.pnombre}}</strong></p>
                </div>
                <div class="col-md-6">
                 <h6><strong>Apellido</strong></h6>
              <p><strong>{{datosdelturno.papellido}}</strong></p>
                </div>
              </div>
          <!-- -------------------------------------------------------------------------- -->
<div class="row justify-content-center">
            <div v-show="estadoturno =='' || estadoturno == undefined" class="col-lg-6 col-md-6 col-12" style="cursor: pointer;">
<a
                  @click="llamar_turno_nuevo('I','LLAMAR',0)"
                  class="card bg-gradient-info border-0"
                >
                <div class="card-body" >
                  <div class="row">
                    <div class="col text-center">
                      <span class="h3 font-weight-bold mb-0 text-white">LLAMAR TURNO</span>
                      <br>
                      <i class="ni ni-button-play coloriconos ni-5x"></i>
                    </div>
                  
                  </div>
                </div>
</a>
            </div>
             
            <div v-show="estadoturno =='S'" class="col-lg-6 col-md-6 col-12" style="cursor: pointer;">
              <a
                  @click="llamar_turno_nuevo('F','FINALIZAR',1)"
                  class="card bg-gradient-danger border-0"
                >
                <div class="card-body" >
                  <div class="row">
                    <div class="col text-center">
                     <span class="h3 font-weight-bold mb-0 text-white">FINALIZAR TURNO</span>
                     <br>
                     <i class="ni ni-button-pause coloriconos ni-5x"></i>
                    </div>
                   
                  </div>
                </div>
              </a>
            </div>
        </div>     
         
<!-- ------------------------------------------------------------------------------- -->
      </div>
      <div v-show="seleccionartap2">
        <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <div>
              <div class="row">
                <div class="col-md-6">
                  <div class="form-group">
                    <input
                      class="form-control"
                      v-model="numerocedula"
                      placeholder="Buscar por nombre"
                      type="text"
                    />
                  </div>
                </div>
              </div>
              <div v-if="datostodoslosturnos!= ''" class="table-responsive"
              >
              <div style="width:auto; height:380px; overflow:auto;">
                <table class="table align-items-center">
                  <thead class="thead-light">
                    <tr>
                      <th>Documento</th>
                      <th>Nombre</th>
                      <th>Turno</th>
                      <th>estado</th>
                      <th>Hora Ingreso</th>
                      <th>Hora Salida</th>
                      <!-- <th>Llamar</th> -->
                    </tr>
                  </thead>
                  <tbody v-for="(tur, index) in datostur" :key="index">
                    <tr>
                      <td>{{ tur.documento }}</td>
                      <td class="text-center">{{ tur.cliente }}</td>
                      <td class="text-center">{{ tur.turno }}</td>
                      <td class="text-center">
                        <div v-if="tur.estadoturno == 'Activo'">
                <span class="badge badge-sm bg-gradient-success">{{ tur.estadoturno }}</span>
                        </div>
                        <div v-else-if="tur.estadoturno == 'Finalizado'">
                <span class="badge badge-sm bg-gradient-danger">{{ tur.estadoturno }}</span>
                        </div>
                        <div v-else>
                  <span class="badge badge-sm bg-gradient-secondary">{{ tur.estadoturno }}</span>
                        </div>
                        </td>
                      <td class="text-center">{{ formatDate(tur.tiempo_ingreso) }}</td>
                      <td class="text-center">{{ formatDate(tur.tiempo_salida) }}</td>
                       <td class="text-center">
                        <!-- <div v-if="tur.estadoturno == 'Activo'">
                <a type="button" @click="llamarseleccionturno(tur.id,tur.turno)" class="btn btn-sm btn-vimeo btn-icon-only" style="margin-right: 4px;">
                          <i class="ni ni-button-play"></i></a>
                        </div>
                        <div v-else>
                  <span class="badge badge-sm bg-gradient-secondary">Atendido</span>
                        </div> -->
                        </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
      </div>
    </div>
  </div>

            
            </div>
          </div>
        </div>
        <div class="col-md-4">
           <div class="card card-profile">
    <img src="../assets/images/loginimagen.png" alt="Image placeholder" class="card-img-top" />
    <div class="row justify-content-center">
      <div class="col-4 col-lg-4 order-lg-2">
        <div class="mt-n4 mt-lg-n6 mb-4 mb-lg-0">
          <a href="javascript:;">
            <img
              src="../assets/img/team-2.png"
              class="rounded-circle img-fluid border border-2 border-white"
            />
          </a>
        </div>
      </div>
    </div>
    <div v-show="estadoturno =='S'" class="card-header text-center border-0 pt-0 pt-lg-2 pb-4 pb-lg-3">
      <div class="d-flex justify-content-between">
        <a @click="llamar_de_nuevo()" class="btn btn-sm btn-info mb-0 d-lg-block">Rellamar</a>
        <a @click="redirigir_el_turno()" class="btn btn-sm btn-success mb-0 d-lg-block">Redirigir</a>
        <a @click="soltarelturno()" class="btn btn-sm btn-dark float-right mb-0 d-lg-block">Soltar</a>
      </div>
    </div>
    <div class="card-body pt-0">
      <div class="row">
        <div class="col">
          <div class="d-flex justify-content-center">
            <div class="d-grid text-center">
              <span class="text-lg font-weight-bolder">{{datoscantidad.ACTIVOS}}</span>
              <span class="text-sm opacity-8">En Espera</span>
            </div>
            <div class="d-grid text-center mx-4">
              <span class="text-lg font-weight-bolder">{{datoscantidad.FINALIZADO}}</span>
              <span class="text-sm opacity-8">Atendidos</span>
            </div>
            <div class="d-grid text-center">
              <span class="text-lg font-weight-bolder">{{datoscantidad.TURNOS}}</span>
              <span class="text-sm opacity-8">Totales</span>
            </div>
          </div>
        </div>
      </div>
      <div class="text-center mt-4">
        <span class="text-sm opacity-8">{{departamento_nombre}} - {{municipio_nombre}}</span>
        <br>
        <span class="text-sm opacity-8">SEDE - {{sede_nombre}}</span>
        <br>
        <span class="text-sm opacity-8">SERVICIO - {{servicio_nombre}}</span>
        <br>
        <span class="text-sm opacity-8">{{modulo_nombre}}</span>
      </div>
    </div>
  </div>
        </div>
      </div>
    </div>
</template>

<script>
import axios from "axios";

export default {
  name: "profile",
  data() {
    return {
      datoscantidad:'',
      datosdelturno:'',
      estadoturno: '',
       seleccionartap1:true,
       seleccionartap2:false,
       numerocedula:"",
       datostodoslosturnos:"",
       servicios:[],
       id_servicio:"",
       departamento_nombre:"",
      municipio_nombre:"",
      sede_nombre:"",
      servicio_nombre:"",
      modulo_nombre:"",

    };
  },
  computed: {
    datostur() {
      return this.datostodoslosturnos.filter(item => {
        return item.documento.toLowerCase().includes(this.numerocedula.toLowerCase()) ||
               item.estadoturno.toLowerCase().includes(this.numerocedula.toLowerCase());
      });
    },
  },
  mounted() {
    this.seleccionartap(1);
    this.cantidad_de_turnos();
    this.servicios_activos();
    this.departamento_nombre = sessionStorage.getItem('departamento_nombre');
    this.municipio_nombre = sessionStorage.getItem('municipio_nombre');
    this.sede_nombre = sessionStorage.getItem('sede_nombre');
    this.modulo_nombre = sessionStorage.getItem('modulo_nombre');
    if(sessionStorage.getItem('servicio_nombre') == sessionStorage.getItem('servicio_nombre2')){
      this.servicio_nombre = sessionStorage.getItem('servicio_nombre');
    } else{
      this.servicio_nombre = sessionStorage.getItem('servicio_nombre') +'-'+ sessionStorage.getItem('servicio_nombre2');
    }
  },
    methods: {
      seleccionartap(opcion) {
            switch (opcion) {
              case 1:
              this.seleccionartap1 = true;
              this.seleccionartap2 = false;
              break;
              case 2:
              this.datosdelosturnos();
              this.seleccionartap1 = false;
              this.seleccionartap2 = true;
              break;
              default:
            }
          },
    servicios_activos() {
      const peticion ={
      departamento:localStorage.getItem("departamento"),
      municipio:localStorage.getItem("municipio"),
      sede:localStorage.getItem("sede_usuario")
      }
        axios.post("llamar_servicios",peticion)
          .then((respuesta) => {
            this.servicios = respuesta.data;
          }).catch((error) => {
            if(error.response.status == 400){
               this.$swal.fire(
                "Ups!!",
                "Token Invalido Cierre Session e Ingrese de Nuevo",
                "error"
              );
            }
          });
    },
    cantidad_de_turnos() {
        axios.post("ver_cantidad_turnos")
          .then((respuesta) => {
              this.datoscantidad = respuesta.data[0];
          }).catch((error) => {
            if(error.response.status == 400){
               this.$swal.fire(
                "Ups!!",
                "Token Invalido Cierre Session e Ingrese de Nuevo",
                "error"
              );
            }
          });
    },
     datosdelosturnos() {
        axios.post("detalleturnos")
          .then((respuesta) => {
              this.datostodoslosturnos = respuesta.data;
          }).catch((error) => {
            if(error.response.status == 400){
               this.$swal.fire(
                "Ups!!",
                "Token Invalido Cierre Session e Ingrese de Nuevo",
                "error"
              );
            }
          });
    },
    formatDate(date) {
        var d = new Date(date);
        var dd = ('0' + d.getDate()).slice(-2);
        var mm = ('0' + (d.getMonth() + 1)).slice(-2);
        var yyyy = d.getFullYear();
        var hh = d.getHours();
        var mi = d.getMinutes();
        return dd + '/' + mm + '/' + yyyy +' '+hh+':'+mi+':00';
      },
    llamar_turno_nuevo(accion,mensaje,numero) {
       this.$swal
          .fire({
            title: mensaje,
            text: "Esta seguro de "+mensaje+" Turno!",
            icon: "info",
            showDenyButton: false,
            showCancelButton: true,
            confirmButtonText: mensaje,
            cancelButtonColor: '#d33',
          })
          .then((result) => {
            if (result.isConfirmed) {
              this.$swal.fire({
        html: 'Cargando por favor espere.',
        allowOutsideClick: false,
        timerProgressBar: true,
        didOpen: () => {
          this.$swal.showLoading()
        }
      })
        const tokenpeticion = {
          v_accion:accion
        };
        axios
          .post("llamarturno", tokenpeticion)
          .then((respuesta) => {
            this.estadoturno = '';
            this.$swal.close()
            if(respuesta.data[0].codigo == 1){
              this.conteo_servicio(numero);
              this.$swal.fire(
                "Exitoso",
                "Turno Finalizado Correctamente",
                "success"
              );
            }else if (respuesta.data[0].codigo == 0){
              this.datosdelturno = respuesta.data[0];
              this.estadoturno = respuesta.data[0].estado_turno;
              this.cantidad_de_turnos();
            }else{
              this.$swal.fire(
                "Ups!!",
                "No hay Turnos Pendientes",
                "info"
              );
            }
          }).catch((error) => {
            if(error.response.status == 400){
               this.$swal.fire(
                "Ups!!",
                "Token Invalido Cierre Session e Ingrese de Nuevo",
                "error"
              );
            }
          });
  }});
    },
    conteo_servicio(numero){
      var conteomenosuno = localStorage.getItem('menosuno') - numero;
      console.log(conteomenosuno);
      console.log(numero);
        localStorage.setItem("menosuno", conteomenosuno);
        const servicio = localStorage.getItem('servicio');
        const servicio2 = localStorage.getItem('servicio2');
        const conteoservicio = localStorage.getItem('conteoservicio');
        const conteoservicio2 = localStorage.getItem('conteoservicio2');
        setTimeout(() => {
          const contar = localStorage.getItem('menosuno');
          if(contar == 0){
            localStorage.setItem("servicio", servicio2);
            localStorage.setItem("servicio2", servicio);
            localStorage.setItem("conteoservicio", conteoservicio2);
            localStorage.setItem("conteoservicio2", conteoservicio);
            localStorage.setItem("menosuno", conteoservicio2);
          }
        }, 1000);
    },
    llamar_de_nuevo() {
      const tokenpeticion = {
          numerodeturno:this.datosdelturno.id
        };
        axios.post("llamardenuevo",tokenpeticion)
          .then((respuesta) => {
            console.log(respuesta);
          }).catch((error) => {
            if(error.response.status == 400){
               this.$swal.fire(
                "Ups!!",
                "Token Invalido Cierre Session e Ingrese de Nuevo",
                "error"
              );
            }
          });
    },
    soltarelturno() {

      this.$swal.fire({
        html: 'Cargando por favor espere.',
        allowOutsideClick: false,
        timerProgressBar: true,
        didOpen: () => {
          this.$swal.showLoading()
        }
      });
      const tokenpeticion = {
          numerodeturno:this.datosdelturno.id
        };
        axios.post("soltar_turno",tokenpeticion)
          .then((respuesta) => {
            this.$swal.close()
            const dato = JSON.parse(respuesta.data[0].codigo);
             if(dato.codigo == 0){
              this.$swal.fire(
                "Exito",
                "Turno Liberado Correctamente",
                "info"
              );
              this.estadoturno="";
              this.cantidad_de_turnos();
              this.datosdelosturnos();
            }else{
              this.$swal.fire(
                "Ups!!",
                "No se Logro Liberar el Turno",
                "info"
              );
            }
          }).catch((error) => {
            if(error.response.status == 400){
               this.$swal.fire(
                "Ups!!",
                "Token Invalido Cierre Session e Ingrese de Nuevo",
                "error"
              );
            }
          });
    },
    redirigir_el_turno() {
       this.$swal
          .fire({
            title: "Redirigir",
            text: "Esta seguro de Redirigir el Turno!",
            icon: "info",
            showDenyButton: false,
            showCancelButton: true,
            confirmButtonText: "Redirigir",
            cancelButtonColor: '#d33',
             html: `<div class="col-md-12">
                    <label class="form-control-label">Servicio</label>
                   <div class="form-group"> 
                   <select id="my-select" value="${this.id}" name="id_servicio" id="id_servicio" class="form-control">
                   <option value="">Seleccionar Servicio</option>
                    ${this.servicios.map(cat => `<option value="${cat.id}">${cat.nombre_servicio}</option>`)}
                    </select>
                    </div>
                    </div>`,
          })
          .then((result) => {
            if (result.isConfirmed) {
        const tokenpeticion = {
          v_datos_turno: this.datosdelturno,
          v_servicio_seleccionado:document.getElementsByName('id_servicio')[0].value
        };
        axios
          .post("redirigirelturno", tokenpeticion)
          .then((respuesta) => {
            if(respuesta.data[0].codigo ==0){
              this.$swal.fire(
                "Exito",
                "Turno Redirigido Correctamente",
                "success"
              )
              this.estadoturno="";
            }else{
               this.$swal.fire(
                "Ups!!",
                "No se Logro Redirigir el Turno",
                "info"
              );
            }
          }).catch((error) => {
            if(error.response.status == 400){
               this.$swal.fire(
                "Ups!!",
                "Token Invalido Cierre Session e Ingrese de Nuevo",
                "error"
              );
            }
          });
  }});
    },

llamarseleccionturno(idturno,numeroturno){
 this.$swal
          .fire({
            title: "Llamar turno Prioridad",
            text: "Esta seguro de "+numeroturno+" Turno!",
            icon: "question",
            showDenyButton: false,
            showCancelButton: true,
            confirmButtonText: "Llamar",
            cancelButtonColor: '#d33',
          })
          .then((result) => {
            if (result.isConfirmed) {
        const tokenpeticion = {
          v_accion:idturno,
          v_accion_pantalla:"I"
        };
        axios
          .post("llamarprioridad", tokenpeticion)
          .then((respuesta) => {
            if(respuesta.data[0].turno =="" || respuesta.data[0].turno== undefined){
              this.$swal.fire(
                "Ups!!",
                "No se Encontraron Turnos Pendientes",
                "info"
              );
            }else{
              this.datosdelturno = respuesta.data[0];
              this.estadoturno = respuesta.data[0].estado_turno;
              this.cantidad_de_turnos();
              this.seleccionartap(1);
            }
          }).catch((error) => {
            if(error.response.status == 400){
               this.$swal.fire(
                "Ups!!",
                "Token Invalido Cierre Session e Ingrese de Nuevo",
                "error"
              );
            }
          });
  }});
}

  },
};


//          $scope.changeItem = function(item){
//   $scope.item = JSON.parse(item)
//   console.log($scope.item)
// }
// <div class="col l2 m2 s2" style="padding-left: 20px; padding-right: 0px;" ng-init="periodo=0">
//                 <label style="padding-left: 25%;">Periodo:</label>
//                 <select ng-model="periodo" style="display: flex;border: 1px solid #dee2e6; border-radius: 0.25rem;" ng-change="changeItem(periodo)">
//                   <option value="0" ng-disabled="true">Seleccionar Periodo</option>
//                   <option ng-repeat="periodo in Periodos" value="{{periodo}}">{{periodo.NOMBRE}}</option>
//                 </select>
//               </div>

//  html: `<input id="my-input" value="${
//           this.name
//         }" placeholder="Name" class="swal2-input">
//           <select id="my-select" value="${
//             this.parent
//           }" name="parent" class="form-control">
//             <option value="">nothing</option>
//             ${this.categories.map(
//               cat => `<option value="${cat.id}">${cat.name}</option>`
//             )}
//           </select>`,
</script>
<style scoped>
.coloriconos{
  color:white;
}
</style>
